/**
 * Color Mode Utilities
 *
 * Utilities for detecting and working with color modes (light/dark).
 */

/**
 * Detects if dark mode is currently active
 * Checks for data-theme attribute, prefers-color-scheme media query, or body class
 *
 * @returns true if dark mode is active, false otherwise
 */
export function isDarkMode(): boolean {
  if (typeof window === "undefined") return false;

  try {
    // next-themes with attribute="class" adds "dark" or "light" class to <html>
    return document.documentElement.classList.contains("dark");
  } catch {
    return false;
  }
}
